module.exports = __webpack_public_path__ + "static/img/sc4.2073bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202104sc/sc4.png
// module id = 9oj8
// module chunks = 0